import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InMemoryCachingService {
  private lastActiveTabUrl: string = '';

  constructor() { }

  getLastActiveTabUrl(): string {
    return this.lastActiveTabUrl;
  }
  setLastActiveTabUrl(url: string) {
    this.lastActiveTabUrl = url;
  }
}
